import dayjs from 'dayjs';

export function parseFilterDateValue(value) {
  if (value == null || value === '') return null;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed : null;
}

export function validateDateRangePair(fromValue, toValue) {
  const from = parseFilterDateValue(fromValue);
  const to = parseFilterDateValue(toValue);

  if (fromValue != null && fromValue !== '' && !from) {
    return { isValid: false, resetFrom: true, resetTo: false };
  }
  if (toValue != null && toValue !== '' && !to) {
    return { isValid: false, resetFrom: false, resetTo: true };
  }
  if (from && to && from.isAfter(to, 'day')) {
    return { isValid: false, resetFrom: true, resetTo: true, isRangeInvalid: true };
  }

  return { isValid: true, from, to };
}

export function buildValidatedFilterSearchParams(data, formList, formModel) {
  const searchParams = {};
  const invalidFields = [];

  formList.forEach((sectionKey, formNumber) => {
    const sectionData = data?.[sectionKey];
    if (!sectionData || typeof sectionData !== 'object') return;

    const elements = formModel?.[sectionKey]?.elements ?? [];
    elements.forEach((elem) => {
      if (elem.type !== 'date' && elem.type !== 'datetime') return;

      const fromKey = `${elem.label}-From`;
      const toKey = `${elem.label}-To`;
      const fromValue = sectionData[fromKey];
      const toValue = sectionData[toKey];
      const validation = validateDateRangePair(fromValue, toValue);

      if (!validation.isValid) {
        if (validation.resetFrom) {
          invalidFields.push(`${formList[formNumber]}.${fromKey}`);
        }
        if (validation.resetTo) {
          invalidFields.push(`${formList[formNumber]}.${toKey}`);
        }
        return;
      }

      if (validation.from) {
        searchParams[`${sectionKey}.${elem.label}.from`] = validation.from.toJSON();
      }
      if (validation.to) {
        searchParams[`${sectionKey}.${elem.label}.to`] = validation.to.toJSON();
      }
    });

    Object.entries(sectionData).forEach(([key, value]) => {
      if (value == null || value === '') return;
      if (key.includes('-To') || key.includes('-From')) return;
      searchParams[`${sectionKey}.${key}.equal`] = value;
    });
  });

  return { searchParams, invalidFields };
}
